import React, { useState, useEffect } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TablePagination,
  Paper,
  Box,
  IconButton,
  Button,
  Modal,
  Typography,
} from "@mui/material";
import { useOutletContext, useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { esignToolApi } from "../../services/esignApi";
import { pdfToolApi } from "../../services/PdfEditor/pdfToolApi";
import { esignIcons } from "../Esign/icons";
import { getStatusStyles } from "../../heplers";
import { uploadDocument } from "../../store/reducers/uploadDocumentSlice";
import { apiEndpoint } from "../../urls";
import Loader from "../Loader";
import { refreshToken } from "../../store/reducers/pdfEditorTokenSlice";
import PdfPreview from "../PdfPreview/pdfPreview";
import TemplatePdfPreview from "../PdfPreview/templatePreview";
import { useLogger } from "../../hooks/useLogger";

const TemplatesListView = ({filteredDocs}) => {
  const logEvent = useLogger();
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [page, setPage] = useState(0);
  const [documents, setDocuments] = useState([]);
  const { open } = useOutletContext();
  const { profileData } = useSelector((state) => state.profile);
  const { pdfEditortoken } = useSelector((state) => state.pdfEditortoken);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [loader, setLoader] = useState(false);
  const [previewDocument, setPreviewDocument] = useState(false);
  const [previewDoc, setPreviewDoc] = useState({});

  const [menuAnchorEl, setMenuAnchorEl] = useState(null);
  const [selectedDoc, setSelectedDoc] = useState(null);
  const [selectedPreviewDoc, setSelectedPreviewDoc] = useState(null);

  const handleMenuOpen = (event, doc) => {
    setMenuAnchorEl(event.currentTarget);
    setSelectedDoc(doc);
  };

  const handleMenuClose = () => {
    setMenuAnchorEl(null);
    setSelectedDoc(null);
  };

  const handleExpire = () => {
    console.log("Expire document:", selectedDoc?.document_id);
    handleMenuClose();
  };

  useEffect(() => {
    if (selectedDoc) {
      handleNewRequest(selectedDoc);
    }
  }, [selectedDoc]);

  const handleNewRequest = async (selectedDoc) => {
    logEvent('Clicked', 'New Request Clicked', 'Documents/Template');

    if(pdfEditortoken?.access && selectedDoc?.document_id)
    {
      setLoader(true)
      console.log(selectedDoc)
      try {
        const response = await pdfToolApi.getSelectedDocuments(pdfEditortoken?.access, selectedDoc?.document_id );
        setLoader(false)
        if (response.status) {
          console.log(response)
          const documentUrl = apiEndpoint.pdfBaseUri+response?.data?.document_url;

          if (!documentUrl) {
              console.error("Document URL not found in response.");
              return;
          }
          const checkResponse = await fetch(documentUrl, { method: 'HEAD' });
          if (!checkResponse.ok) {
              console.error(`Document not found: ${documentUrl}`);
              return;
          }
          uploadFileFromUrl(documentUrl)
        }
      } catch (error) {
        setLoader(false)
        if (error.response?.status === 401 && error.response?.data?.code === "token_not_valid") {
          console.warn("Access token expired, attempting to refresh...");
          dispatch(refreshToken())
            .unwrap()
            .then((newTokenData) => {
              if (newTokenData.access) {
                handleNewRequest();
              }
            })
            .catch((refreshError) => {
              console.error("Token refresh failed, user may need to log in again.", refreshError);
            });
        } else {
          console.error("Error fetching documents:", error);
        }
      } 
    }
  };

  function uploadFileFromUrl(fileUrl, uploadEndpoint) {
    fetch(fileUrl)
      .then(response => response.blob())
      .then(blob => {
          const file = new File([blob], "uploadedFile.pdf", { type: blob.type });
          const formData = new FormData();
          dispatch(uploadDocument({ token: pdfEditortoken?.access, file }));
          navigate("/esign/new-esign", { replace: true });
      })
      .catch(error => console.error("Error fetching file:", error));
  }

  useEffect(() => {
    if (selectedPreviewDoc) {
      handlePreview(selectedPreviewDoc);
    }
  }, [selectedPreviewDoc]);

  const handlePreview = async (selectedPreviewDoc) => {
    logEvent('Clicked', 'Preview Clicked', 'Documents/Template');
    try {
        if (!selectedPreviewDoc?.file_url) {
            console.error("No file URL provided.");
            return;
        }

        setLoader(true);
        const documentUrl = selectedPreviewDoc.file_url;

        const checkResponse = await fetch(documentUrl, { method: 'GET' });

        if (!checkResponse.ok) {
            throw new Error(`Document not found: ${documentUrl}`);
        }

        const previewDocumentData = {
            document_url: documentUrl,
            document_name: selectedPreviewDoc.document_name
        };

        setPreviewDocument(true);
        setPreviewDoc(previewDocumentData);
    } catch (error) {
        console.error("Error fetching document:", error.message);
    } finally {
        setLoader(false);
    }
  };

  const handleDownload = async (doc) => {
    logEvent('Clicked', 'Download Clicked', 'Documents/Template');
    if(doc?.is_uploaded_to_s3)
    {
      if (!doc?.uuid || !profileData?.username || !doc?.mobile) {
        console.error("Missing required parameters for download.");
        return;
      }
      setLoader(true);
      const payload = {
        "file_name": `PDFs/${profileData?.username}/${doc?.uuid}/${doc?.mobile}/pdfForEsign_signedFinal.pdf`
      };
      try {
        const response = await fetch(`${apiEndpoint.esignBaseUri}/EsignServices/download_pdf_file_from_s3`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(payload),
        });

        if (!response.ok) {
          setLoader(false);
          throw new Error(`HTTP error! Status: ${response.status}`);
        }
    
        const data = await response.json();
        console.log(data)
        const URLdata = data.url;
        var responsefile = await fetch(URLdata);
        if (!responsefile.ok) {
          setLoader(false);
          throw new Error(`Failed to fetch file: ${responsefile.statusText}`);
        }

        const blob = await responsefile.blob();
        const a = document.createElement('a');
        const url = window.URL.createObjectURL(blob);
        a.href = url;
        var fileName = "pdfForEsign_signedFinal";
        const file_extension = "pdf"
        a.download = fileName + '.' + file_extension;
        document.body.appendChild(a);
        a.click();
        window.URL.revokeObjectURL(url);
        document.body.removeChild(a);
        setLoader(false);

      } catch (error) {
        console.error('Error occurred while fetching the URL:', error.message);
        setLoader(false);
      }
    }
    else
    {
      if(doc?.pdf_path)
      { 
        setLoader(true);
        let URLdata = `${apiEndpoint.esignBaseUri}/PDFs/${profileData?.username}/${doc?.uuid}/${doc?.mobile}/pdfForEsign_signedFinal.pdf`;
        var responsefile = await fetch(URLdata);
        if (!responsefile.ok) {
          setLoader(false);
          throw new Error(`Failed to fetch file: ${responsefile.statusText}`);
        }

        const blob = await responsefile.blob();
        const a = document.createElement('a');
        const url = window.URL.createObjectURL(blob);
        a.href = url;
        var fileName = "pdfForEsign_signedFinal";
        const file_extension = "pdf"
        a.download = fileName + '.' + file_extension;
        document.body.appendChild(a);
        a.click();
        window.URL.revokeObjectURL(url);
        document.body.removeChild(a);
        setLoader(false);
      }
    }
  };

  return (
    <>      
        <Paper sx={{ width: "100%", overflow: "auto", boxShadow: "none", height: "90%", mt: "15px" }}>
            <TableContainer>
                <Table>
                    <TableHead sx={{ background: "#F5F5F5", fontSize: "15px", fontWeight: 500, color: "#1D1D1D" }}>
                    <TableRow>
                        <TableCell sx={{  pl: "30px", }}>S. No.</TableCell>
                        <TableCell>Template Name</TableCell>
                        {/* <TableCell>Created On</TableCell> */}
                        <TableCell>Action</TableCell>
                    </TableRow>
                    </TableHead>
                    <TableBody>
                    {filteredDocs.length > 0 ? (
                        filteredDocs.map((row, index) => (
                        <TableRow key={row.document_name} sx={{ "&:hover": { backgroundColor: "#fafafa" }, }}  >
                            <TableCell sx={{ pl: "30px", cursor: "pointer" }}>{(page * rowsPerPage + index + 1).toString().padStart(2, "0")}</TableCell>
                            <TableCell sx={{ cursor: "pointer" }}>{row.document_name}</TableCell>
                            {/* <TableCell sx={{ cursor: "pointer" }}>
                                {new Date(row.created_at).toLocaleString()}
                            </TableCell> */}
                            <TableCell onClick={(e) => e.stopPropagation()} sx={{ display: "flex", gap: "18px" }}>
                                <IconButton onClick={() => {
                                    logEvent('Clicked', 'Preview Clicked', 'Documents/Template');
                                    setSelectedPreviewDoc(null);
                                    setTimeout(() => setSelectedPreviewDoc(row), 0);
                                }}>
                                    {esignIcons.eyeBlueIcon}
                                </IconButton>
                                {/* <IconButton onClick={() => handleDownload(row)}>
                                    {esignIcons.addMoreIcon}
                                </IconButton>
                                <IconButton onClick={() => handleDownload(row)}>
                                    {esignIcons.deleteIconRed}
                                </IconButton> */}
                                {/* <IconButton onClick={(e) => handleMenuOpen(e, row)}>
                                {esignIcons.moreIcon}
                                </IconButton> */}
                            </TableCell>
                        </TableRow>
                        ))
                    ) : (
                        <TableRow>
                        <TableCell colSpan={6} align="center">
                            No documents found
                        </TableCell>
                        </TableRow>
                    )}
                    </TableBody>
                </Table>
            </TableContainer>
            <TablePagination
                rowsPerPageOptions={[5, 10]}
                component="div"
                count={filteredDocs.length}
                rowsPerPage={rowsPerPage}
                page={page}
                onPageChange={(_, newPage) => setPage(newPage)}
                onRowsPerPageChange={(event) =>
                    setRowsPerPage(parseInt(event.target.value, 10))
                }
            />
        </Paper>
        {loader && <Loader />}

        <Modal open={previewDocument} onClose={() => setPreviewDocument(false)}>
            <Box
                sx={{
                    position: "absolute",
                    top: "50%",
                    left: "50%",
                    transform: "translate(-50%, -50%)",
                    width: 1090,
                    height: 610,
                    backgroundColor: "#fff",
                    boxShadow: 24,
                    overflow: "hidden",
                    borderRadius: "20px",
                }}
            >
                <Box sx={{ display: "flex", flexDirection: "column", justifyContent: "space-between", height: "100%" }}>
                    {previewDocument && <TemplatePdfPreview previewDoc={previewDoc} setPreviewDoc={setPreviewDoc} previewDocument={previewDocument} setPreviewDocument={setPreviewDocument} />}
                </Box>
            </Box>
        </Modal>
      </>
  );
};

export default TemplatesListView;
